import React from 'react';
import { Session } from '../models/Schedule';
import { Speaker } from '../models/Speaker';
import { IonCard, IonCardHeader, IonItem, IonLabel, IonAvatar, IonCardContent, IonList } from '@ionic/react';
import './SpeakerItem.css';


interface SpeakerItemProps {
  speaker: Speaker;
  sessions: Session[];
}

const SpeakerItem: React.FC<SpeakerItemProps> = ({ speaker, sessions }) => {
  return (
    <>
      <IonCard className="speaker-card glass-effect">
        <IonCardHeader>
          <IonItem button detail={false} lines="none" className="glass-effect" routerLink={`/tabs/speakers/${speaker.id}`}>
            <IonAvatar slot="start">
              <img
                src={speaker.profilePic}
                alt={`${speaker.name} profile pic`}
              />
            </IonAvatar>
            <IonLabel style={{ whiteSpace: 'normal' }}>
              <h2 className="speaker-name text-primary" style={{ whiteSpace: 'normal' }}>{speaker.name}</h2>
              <p className="speaker-title">{speaker.title}</p>
              {speaker.logo && (
                <div style={{ marginTop: '8px' }}>
                  <img
                    src={speaker.logo}
                    alt={`${speaker.name} logo`}
                    style={{
                      maxHeight: '50px',
                      maxWidth: '100px',
                      objectFit: 'contain'
                    }}
                  />
                </div>
              )}
            </IonLabel>
          </IonItem>
        </IonCardHeader>

        <IonCardContent>
          <IonList lines="none">
            {sessions.map(session => (
              <IonItem detail={false} routerLink={`/tabs/speakers/sessions/${session.id}`} key={session.id} className="glass-effect ion-margin-vertical session-item">
                <IonLabel style={{ whiteSpace: 'normal' }}>
                  <h3 style={{ whiteSpace: 'normal' }}>{session.name}</h3>
                </IonLabel>
              </IonItem>
            ))}
            <IonItem detail={false} routerLink={`/tabs/speakers/${speaker.id}`} className="gradient-bg-primary ion-margin-vertical" style={{borderRadius: 'var(--glass-border-radius)'}}>
              <IonLabel style={{ whiteSpace: 'normal', color: 'white' }}>
                <h3 style={{ whiteSpace: 'normal', fontWeight: "bold" }}>Más información de: {speaker.name}</h3>
              </IonLabel>
            </IonItem>
          </IonList>
        </IonCardContent>
      </IonCard>
    </>
  );
};

export default SpeakerItem;